async function initializeSEPACheckout() {
  if(window._sepa_checkout_button_initialized) {
    return;
  }
  window._sepa_checkout_button_initialized = true;
  window.sellingPlanMapping = window._fhSPM
  
  const apiBaseUrl = window.Shopify.routes.root;
  let cachedCart = null;
  const getCart = async () => cachedCart ?? (cachedCart = (await fetchCart()));
  const getSellingPlanId = (shopifyId) => shopifyId.split("/").pop();
  const fetchCart = async () => (await fetch(`${apiBaseUrl}cart.js`)).json();
  const updateCart = async (payload) => (await fetch(`${apiBaseUrl}cart/update.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  })).json();
  const clearCart = async () => fetch(`${apiBaseUrl}cart/clear.js`, { method: "POST" });
  const addToCart = async (payload) => (await fetch(`${apiBaseUrl}cart/add.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  })).json();

  const updateCheckoutButtonDisabledState = (disabled) => {
    document.querySelectorAll("button.fh-sepa-checkout, shopify-buy-it-now-button>button, button[name='checkout']").forEach((button) => {
      button.disabled = disabled;
    });
    document.querySelectorAll('shopify-accelerated-checkout-cart > *').forEach((option) => {
      if (!option.button) { return; }
      if (disabled) {
        option.button.setAttribute('disabled', 'true')
      } else {
        option.button.removeAttribute('disabled')
      }
    })
  };
  const replacePlans = async (planMapping) => {
    const cart = await fetchCart();
    if (!cart.items.some(item => item.selling_plan_allocation && planMapping[item.selling_plan_allocation.selling_plan.id])) {
      return false
    }
    const items = cart.items.map((item) => ({
      id: item.variant_id,
      quantity: item.quantity,
      ...(item.selling_plan_allocation
        ? {
          selling_plan:
            planMapping[item.selling_plan_allocation.selling_plan.id] ??
            item.selling_plan_allocation.selling_plan.id,
        }
        : {}),
      properties: item.properties,
    }));
    await clearCart();
    await addToCart({ items, attributes: cart.attributes });
    return true
  };

  const planMapping = Object.fromEntries(
    window._fhSPM.map((m) => [
      getSellingPlanId(m["native"]),
      getSellingPlanId(m["sepa"])
    ])
  );
  const getCartInputs = () => {
    const attributes = document.querySelectorAll("input[name^='attributes['], textarea[name^='attributes[']");
    const note = document.querySelector("textarea[name='note'], input[name='note']");
    const payload = {}
    if(note) {
      payload.note = note.value;
    }
    if(attributes) {
      payload.attributes = Object.fromEntries(Array.from(attributes).map((a) => [a.name.replace("attributes[", "").replace("]", ""), a.value]))
    }
    return payload;
  }
  
  const handleClick =  async function(e) {
    console.log(this)
    console.log('click')
    updateCheckoutButtonDisabledState(true);
    await updateCart(getCartInputs());
    await replacePlans(planMapping);
  
    window.location.href = "/checkout";
  };

  const hasSellingPlans = async () => {
    const cart = await getCart();
    return cart.items.some(item => item.selling_plan_allocation);
  }

  window.fhSepaCheckout = handleClick;
}

window.addEventListener("pageshow", initializeSEPACheckout);